import classNames from "classnames";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { getTierColor } from "@ugg/shared/utils/rank-helpers";

interface ProfileIconContainerProps {
  className?: string;
  status?: string;
  tier: string | undefined;
  summonerLevel: number;
  iconId: number;
  isPremium?: boolean;
}

export function ProfileIconContainer(props: ProfileIconContainerProps) {
  const { getProfileIconImg } = getRiotAssetsContext();
  const { className, tier, summonerLevel, iconId, isPremium } = props;
  const tierColor = tier && getTierColor(tier);
  const borderColor = isPremium ? "#f4c874" : tierColor;
  return (
    <div
      className={classNames(
        "relative flex-none w-[93px] h-[93px] max-xs:w-[75px] max-xs:h-[75px] rounded-[6px] border-[2px] border-lavender-400 bg-[#17172e]",
        className,
      )}
      style={{ borderColor }}
    >
      {summonerLevel && (
        <div
          className="absolute z-[2] top-[-16px] left-[50%] translate-x-[-50%] flex items-center justify-center w-[36px] h-[20px] rounded-[4px] border-[1px] border-lavender-400 bg-[#06061f] text-white text-[11px] font-bold"
          style={{ borderColor }}
        >
          {summonerLevel}
        </div>
      )}
      <div className="relative w-full h-full rounded-[4px] border-[2px] border-[#17172e] overflow-hidden">
        {summonerLevel && (
          <div className="absolute top-[-6px] left-[50%] z-[1] translate-x-[-50%] w-[40px] h-[10px] rounded-b-[6px] border-[2px] border-purple-500 bg-[#06061f]" />
        )}
        <img className="w-full h-full rounded-[2px]" src={getProfileIconImg(iconId)} alt="Summoner profile icon" />
      </div>
      {isPremium && (
        <div className="absolute z-[2] bottom-[-14px] left-[50%] translate-x-[-50%] flex items-center justify-center w-[40px] h-[20px] rounded-[4px] border-[1px] border-accent-yellow-400 bg-[#322a2f] text-accent-yellow-400 text-[10px]">
          PLUS
        </div>
      )}
    </div>
  );
}
